/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { CompleteOnboardingResponse } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    completeOnboarding: build.mutation<CompleteOnboardingResponse, void>({
      query: () => ({ body: undefined, method: 'POST', url: `/v1/onboarding/complete` }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as completeOnboardingApi };
export const { useCompleteOnboardingMutation } = injectedRtkApi;
